import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "next",
  "use": "next-usage",
  "viewBox": "0 0 15 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 26\" id=\"next\"><path fill=\"none\" stroke-miterlimit=\"10\" stroke-width=\"3\" d=\"M1 1l12 12L1 25\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol